<app-modal-basic #modal modalContentId="modal-escriturar-nota-entrada" (closed)="handleOnClose()" dialogClass="modal-xxl">
  <div class="app-modal-header">
    <h4 class="modal-title">
      Escrituração de Notas Fiscais de Entrada
    </h4>
    <button style="cursor: pointer;" type="button" class="close basic-close" (click)="handleOnCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="app-modal-body">
    <div class="row mb-3">
      <div class="col-12">
        <b>Fornecedor:</b> {{dados?.fornecedor}}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-auto">
        <b>Série:</b> {{dados?.serie}}
      </div>
      <div class="col-auto">
        <b>Número da NF:</b> {{dados?.numeroNotaFiscal}}
      </div>
      <div class="col-auto">
        <b>Valor Total:</b> {{dados?.valorTotal | currency:'BRL':'symbol':'1.2-2'}}
      </div>
    </div>
    <div class="row mb-4 align-items-center">
      <div class="col-auto">
        <b>Emissão:</b> {{dados?.emissao | date:'dd/MM/yyyy'}}
      </div>
      <div class="col-auto pr-0">
        <b>Data de Entrada:</b>
      </div>
      <ng-container [formGroup]="form">
        <div class="col-auto">
          <app-data formControlName="dataEntrada"></app-data>
          <show-errors [control]="form.controls.dataEntrada"></show-errors>
        </div>
        <div class="col-auto">
          <app-dim-checkbox formControlName="atualizarCustoUnitario" label="Atualizar Custo Unitário"></app-dim-checkbox>
        </div>
      </ng-container>
    </div>

    <app-collapse header="Aplicar a todos">
      <div class="row">
        <div class="col-2 form-group">
          <label class="control-label">CST/CSOSN ICMS</label>
          <ng-select [items]="cstIcms" appendTo="#modal-escriturar-nota-entrada" bindValue="tipo" bindLabel="descricao"
            [(ngModel)]="aplicarATodos.cstIcms">
          </ng-select>
        </div>
        <div class="col-2 form-group">
          <label class="control-label">Alíquota ICMS</label>
          <input type="text" class="form-control" currencyMask inputmode="numeric" [options]="{ prefix: '', precision: 2, allowNegative: false, max: 100 }"
            [(ngModel)]="aplicarATodos.aliquotaIcms">
        </div>
        <div class="col-2 form-group">
          <label class="control-label">CST IPI</label>
          <ng-select [items]="cstIpi" appendTo="#modal-escriturar-nota-entrada" bindValue="tipo" bindLabel="descricao"
            [(ngModel)]="aplicarATodos.cstIpi">
          </ng-select>
        </div>
        <div class="col-2 form-group">
          <label class="control-label">Alíquota IPI</label>
          <input type="text" class="form-control" 
            currencyMask inputmode="numeric" [options]="{ prefix: '', precision: 2, allowNegative: false, max: 100 }"
              [(ngModel)]="aplicarATodos.aliquotaIpi">
        </div>
      </div>
      <div class="row">
        <div class="col-2 form-group">
          <label class="control-label">CST PIS</label>
          <ng-select [items]="cstPis" appendTo="#modal-escriturar-nota-entrada" bindValue="tipo" bindLabel="descricao"
            [(ngModel)]="aplicarATodos.cstPis">
          </ng-select>
        </div>
        <div class="col-2 form-group">
          <label class="control-label">Alíquota PIS</label>
          <input type="text" class="form-control" 
            currencyMask inputmode="numeric" [options]="{ prefix: '', precision: 2, allowNegative: false, max: 100 }"
            [(ngModel)]="aplicarATodos.aliquotaPis">
        </div>
        <div class="col-2 form-group">
          <label class="control-label">CST COFINS</label>
          <ng-select [items]="cstCofins" appendTo="#modal-escriturar-nota-entrada" bindValue="tipo" bindLabel="descricao"
            [(ngModel)]="aplicarATodos.cstCofins">
          </ng-select>
        </div>
        <div class="col-2 form-group">
          <label class="control-label">Alíquota COFINS</label>
          <input type="text" class="form-control" 
            currencyMask inputmode="numeric" [options]="{ prefix: '', precision: 2, allowNegative: false, max: 100 }"
            [(ngModel)]="aplicarATodos.aliquotaCofins">
        </div>
      </div>
      <div class="row">
        <div class="col-4 form-group">
          <label class="control-label">CFOP</label>
          <ng-select [items]="cfops" appendTo="#modal-escriturar-nota-entrada" bindValue="codigo" bindLabel="descricao"
            [(ngModel)]="aplicarATodos.cfop">
          </ng-select>
        </div>
        <div class="col-4 form-group">
          <label class="control-label">Conta Contábil <i class="fa fa-info-circle" ngbTooltip="Opcional, usado apenas para SPED Contribuições (PIS/COFINS)."></i></label>
          <ng-select [items]="contasContabeis" appendTo="#modal-escriturar-nota-entrada" bindValue="id" bindLabel="descricao"
            [(ngModel)]="aplicarATodos.contaContabilID">
          </ng-select>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <button type="button" class="btn btn-primary" (click)="aplicarTodos()">Aplicar a todos</button>
        </div>
      </div>
    </app-collapse>

    <div class="row mt-2" *ngIf="dados">
      <div class="col">
        <form [formGroup]="form" class="w-100">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>NCM</th>
                <th>CST/CSOSN</th>
                <th>% Alíq. ICMS</th>
                <th>CST IPI</th>
                <th>% Alíq. IPI</th>
                <th>CST PIS</th>
                <th>% Alíq. PIS</th>
                <th>CST COFINS</th>
                <th>% Aliq. COFINS</th>
                <th>CFOP</th>
                <th>Conta Contábil <i class="fa fa-info-circle" ngbTooltip="Opcional, usado apenas para SPED Contribuições (PIS/COFINS)."></i></th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of formItens.controls" class="linha-item" [formGroup]="$any(item)">
                <td>{{item.get('ncm').value}}</td>
                <td>
                  <div class="linha-item-texto">{{item.get('$cst').value}}</div>
                  <ng-select [items]="cstIcms" appendTo="#modal-escriturar-nota-entrada" bindValue="tipo" bindLabel="descricao"
                    formControlName="cst" style="width: 160px">
                  </ng-select>
                </td>
                <td>
                  <div class="linha-item-texto">{{item.get('$aliquotaIcms').value | currency:'':'':'1.2-2'}}</div>
                  <input type="text" class="form-control" formControlName="aliquotaIcms" 
                    currencyMask inputmode="numeric" [options]="{ prefix: '', precision: 2, allowNegative: false, max: 100 }">
                </td>
                <td>
                  <div class="linha-item-texto">{{item.get('$cstIpi').value}}</div>
                  <ng-select [items]="cstIpi" appendTo="#modal-escriturar-nota-entrada" bindValue="tipo" bindLabel="descricao"
                    formControlName="cstIpi" style="width: 160px">
                  </ng-select>
                </td>
                <td>
                  <div class="linha-item-texto">{{item.get('$aliquotaIpi').value | currency:'':'':'1.2-2'}}</div>
                  <input type="text" class="form-control" formControlName="aliquotaIpi" 
                    currencyMask inputmode="numeric" [options]="{ prefix: '', precision: 2, allowNegative: false, max: 100 }">
                </td>
                <td>
                  <div class="linha-item-texto">{{item.get('$cstPis').value}}</div>
                  <ng-select [items]="cstPis" appendTo="#modal-escriturar-nota-entrada" bindValue="tipo" bindLabel="descricao"
                    formControlName="cstPis" style="width: 160px">
                  </ng-select>
                </td>
                <td>
                  <div class="linha-item-texto">{{item.get('$aliquotaPis').value | currency:'':'':'1.2-2'}}</div>
                  <input type="text" class="form-control" formControlName="aliquotaPis" 
                    currencyMask inputmode="numeric" [options]="{ prefix: '', precision: 2, allowNegative: false, max: 100 }">
                </td>
                <td>
                  <div class="linha-item-texto">{{item.get('$cstCofins').value}}</div>
                  <ng-select [items]="cstCofins" appendTo="#modal-escriturar-nota-entrada" bindValue="tipo" bindLabel="descricao"
                    formControlName="cstCofins" style="width: 160px">
                  </ng-select>
                </td>
                <td>
                  <div class="linha-item-texto">{{item.get('$aliquotaCofins').value | currency:'':'':'1.2-2'}}</div>
                  <input type="text" class="form-control" formControlName="aliquotaCofins" 
                    currencyMask inputmode="numeric" [options]="{ prefix: '', precision: 2, allowNegative: false, max: 100 }">
                </td>
                <td>
                  <div class="linha-item-texto">{{item.get('$cfop').value}}</div>
                  <ng-select [items]="cfops" appendTo="#modal-escriturar-nota-entrada" bindValue="codigo" bindLabel="descricao"
                    formControlName="cfop" style="width: 110px">
                  </ng-select>
                </td>
                <td>
                  <ng-select [items]="contasContabeis" appendTo="#modal-escriturar-nota-entrada" bindValue="id" bindLabel="descricao"
                    formControlName="contaContabilID" style="min-width: 150px">
                  </ng-select>
                </td>
                <td>
                  {{item.get('$descricao').value}}
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <button type="button" class="btn btn-primary ripple light" (click)="handleOnSave()" [disabled]="loading['escriturar']">
          <app-loading [loading]="loading['escriturar']" [icone]="'fa fa-save'" texto="Gerar NF-e de Entrada"></app-loading>
        </button>

        <button type="button" class="btn btn-danger ripple" (click)="handleOnCancel()" [disabled]="loading['escriturar']">
          <i class="fa fa-close"></i> Cancelar
        </button>
      </div>
    </div>
  </div>

  <div class="app-modal-footer"></div>
</app-modal-basic>